<div [nbSpinner]="loading" nbSpinnerStatus="primary" nbSpinnerSize="giant" class="row">
  <div class="col-md-6">
    <div *ngIf="s3SignedPdfFile" class="pdf-viewer-container">
      <ngx-pdf-viewer [pdfFailed]="pdfFailed" [billPDF]="s3SignedPdfFile" [pdfAbsent]="pdfAbsent"></ngx-pdf-viewer>
    </div>
  </div>
  <div class="col-md-6">
    <div *ngIf="selectedInvoice" class="invoice-container">
      <table class="critical-table-1">
        <tbody>
          <ng-container *ngFor="let key of getKeys(selectedInvoiceFormatted.keyItems)">
            <tr *ngIf="key !== 'lineItems'">
              <td class="key-column font-weight-bold">{{ formatKey(key) }}</td>
              <td class="value-column">{{ selectedInvoiceFormatted.keyItems[key] }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>

      <div class="line-items-section mt-4" *ngIf="selectedInvoice.lineItems && selectedInvoice.lineItems.length">
        <h3 class="line-items-title">Line Items</h3>
        <table class="critical-table-2">
          <thead class="thead">
            <tr>
              <th *ngFor="let itemKey of getKeys(selectedInvoice.lineItems[0])">{{ formatKey(itemKey) }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of selectedInvoice.lineItems">
              <td *ngFor="let itemKey of getKeys(item)">{{ item[itemKey] }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <table class="non-critical-table">
        <tbody>
          <ng-container *ngFor="let key of getKeys(selectedInvoiceFormatted.otherItems)">
            <tr *ngIf="key !== 'lineItems'">
              <td class="key-column font-weight-bold">{{ formatKey(key) }}</td>
              <td class="value-column">{{ selectedInvoiceFormatted.otherItems[key] }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
